import React, { FC, ReactElement } from 'react';

interface IInputProps {
  onClick: () => void;
  title: string | ReactElement;
  width?: string;
  height?: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
}

export const GrayButton: FC<IInputProps> = ({
  title,
  onClick,
  width = null,
  height = '33px',
  type = 'button',
}) => {
  return (
    <div className={`h-[${height}] hover:text-[white`}>
      <button
        type={type}
        className={`overflow-hidden bg-[#211F24] rounded-[8px] ${width ? 'w-[' + width + ']' : 'w-full'} ${height ? 'h-[' + height + ']' : 'h-full'} px-[10px]`}
        onClick={() => onClick()}
      >
        {title}
      </button>
    </div>
  );
};

export const DarkGrayButton: FC<IInputProps> = ({ title, onClick, type = 'button' }) => {
  return (
    <div className="h-[33px]">
      <button
        type={type}
        className={`overflow-hidden bg-[#2B292E] rounded-[8px] w-full h-full px-[10px]`}
        onClick={() => onClick()}
      >
        {title}
      </button>
    </div>
  );
};

export const RedButton: FC<IInputProps> = ({ title, onClick }) => {
  return (
    <div className="h-[33px]">
      <button
        autoFocus={false}
        className={`overflow-hidden bg-[#E23336] rounded-[8px] w-full h-full px-[15px] text-[white]`}
        onClick={() => onClick()}
      >
        {title}
      </button>
    </div>
  );
};

export const YellowButton: FC<IInputProps> = ({ title, onClick }) => {
  return (
    <div className="h-[33px]">
      <button
        autoFocus={false}
        className={`overflow-hidden bg-[#a6bd1c] rounded-[8px] w-full h-full px-[15px] text-[white]`}
        onClick={() => onClick()}
      >
        {title}
      </button>
    </div>
  );
};

export const RedTransparentButton: FC<IInputProps> = ({ height = '33px', title, onClick }) => {
  return (
    <div className={`h-[${height}]`}>
      <button
        autoFocus={false}
        className={`overflow-hidden bg-[#201818] rounded-[8px] w-full h-full px-[15px] border border-[#201818] border-solid text-[#A93434] hover:text-[white] hover:border-[#A93434]`}
        onClick={() => onClick()}
      >
        {title}
      </button>
    </div>
  );
};

export const BlueTransparentButton: FC<IInputProps> = ({ height = '33px', title, onClick }) => {
  return (
    <div className={`h-[${height}]`}>
      <button
        autoFocus={false}
        className={`overflow-hidden bg-[#181920] rounded-[8px] w-full h-full px-[15px] border border-[#181920] border-solid text-[#1E90FF] hover:text-[white] hover:border-[#1E90FF]`}
        onClick={() => onClick()}
      >
        {title}
      </button>
    </div>
  );
};

export const TransparentButton: FC<IInputProps> = ({ title, onClick }) => {
  return (
    <div className="h-[33px]">
      <button
        autoFocus={false}
        className={`overflow-hidden bg-[none] rounded-[8px] w-full h-full px-[15px] text-[10px] hover:text-[white] hover:border-[white]`}
        onClick={() => onClick()}
      >
        {title}
      </button>
    </div>
  );
};

export const TransparentBorderedButton: FC<IInputProps> = ({ title, onClick }) => {
  return (
    <div className="h-[33px] ">
      <button
        autoFocus={false}
        className={`overflow-hidden bg-[none] rounded-[8px] w-full h-full px-[15px] text-[14px] border border-solid border-[#959595] text-[#959595] rounded-[50%] hover:text-[white] hover:border-[white]`}
        onClick={() => onClick()}
      >
        {title}
      </button>
    </div>
  );
};

export const BonusButton: FC<IInputProps> = ({ title, onClick }) => {
  return (
    <div
      className={`h-[39px] w-full rounded-[8px] text-[16px] bg-[linear-gradient(90deg,#AFCC04_0%,#1ABE4C_100%)] 
                px-[10px] flex items-center justify-center border border-solid border-[#2B292F] relative overflow-hidden`}
      onClick={() => onClick()}
    >
      Бонус
      <svg
        className="absolute right-[15px] bottom-0"
        width="37"
        height="34"
        viewBox="0 0 37 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.4813 0.805018C21.7526 0.543441 22.2044 0.664586 22.3086 1.02668L25.3394 11.5657C25.4517 11.9561 25.7168 12.2847 26.0753 12.4757L35.7546 17.6301C36.0871 17.8074 36.1114 18.2754 35.7992 18.4863L26.7126 24.6239C26.3761 24.8512 26.1453 25.2056 26.0745 25.6055L24.1629 36.4034C24.0972 36.7744 23.6608 36.9424 23.3637 36.711L14.7171 29.9659C14.3969 29.7161 13.9893 29.6069 13.5871 29.6631L2.72643 31.1812C2.35321 31.2334 2.05847 30.8693 2.18712 30.5151L5.9306 20.2079C6.0692 19.8262 6.0475 19.4042 5.86972 19.0391L1.06928 9.18042C0.904303 8.84157 1.1593 8.44838 1.53596 8.46127L12.4948 8.83679C12.9007 8.85068 13.2956 8.69889 13.588 8.41694L21.4813 0.805018Z"
          stroke="white"
        />
      </svg>
      <svg
        className="absolute right-[75px] bottom-0"
        width="19"
        height="13"
        viewBox="0 0 19 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.8611 1.25449C11.1323 0.992886 11.5842 1.11398 11.6883 1.47615L12.9805 5.96956C13.0928 6.3597 13.3583 6.68765 13.7166 6.87855L17.8431 9.07614C18.1758 9.25331 18.2 9.72132 17.8877 9.93228L14.014 12.5491C13.6774 12.7765 13.4476 13.131 13.3768 13.531L12.562 18.1341C12.4963 18.5052 12.059 18.673 11.7618 18.4414L8.07595 15.5652C7.75571 15.3154 7.34722 15.2059 6.94495 15.2622L2.3148 15.9101C1.94172 15.962 1.64687 15.598 1.77549 15.2439L3.37139 10.85C3.51004 10.4682 3.48831 10.0463 3.31051 9.68114L1.26418 5.47802C1.0992 5.13917 1.3542 4.74598 1.73086 4.75887L6.40332 4.91896C6.80908 4.9328 7.20299 4.78154 7.4953 4.4998L10.8611 1.25449Z"
          stroke="white"
        />
      </svg>
    </div>
  );
};
